import {messages, messagesOverwrite} from '../../constants/messages';

export const overwriteMessages = (message) => {
  switch (message) {
    case messages.cnpjError:
      return [
        {
          text: messagesOverwrite.cnpjError,
          type: 'message-long-error-icon'
        }
      ];
    case messages.cnaeError:
      return [
        {
          text: messagesOverwrite.cnaeError,
          type: 'message-long-error-icon'
        }
      ];

    default:
      return [
        {
          text: message
        }
      ];
  }
};
